import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import CustomLabel from "./custom-label";
import TooltipContent from "./tooltip-content";
import _ from "lodash";
import Teams from "../../../../../api/Teams";

function VerticalBar({ prefix = "", suffix = "", precision = 2, data = [] }) {
  let min = Math.min.apply(null, _.map(data, "value"));
  let max = Math.max.apply(null, _.map(data, "value"));

  if (min === 0 && max === 0) {
    min = -10;
    max = 10;
  } else {
    min = max = Math.max(Math.abs(min), Math.abs(max));
    min *= -1.8;
    max *= 1.8;
  }

  const domain = [min, max];
  const colors = Teams.competitiveColors();

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} barSize={18} layout="vertical">
        <XAxis
          type="number"
          dataKey="value"
          domain={domain}
          axisLine={false}
          tickLine={false}
          tick={false}
        />
        <YAxis type="category" dataKey="name" hide={true} />
        <Tooltip content={<TooltipContent prefix={prefix} suffix={suffix} />} />
        <Bar
          dataKey="value"
          minPointSize={5}
          label={
            <CustomLabel
              prefix={prefix}
              precision={precision}
              suffix={suffix}
              layout="vertical"
            />
          }
        >
          {colors.map((color, i) => (
            <Cell key={i} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default VerticalBar;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/vertical-bar.js